import React, { useEffect } from "react";
import Breadcrumb from "../Breadcrumb";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";

export default function RefundPolicyPage() {
  pageTitle("Refund Policy");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Breadcrumb
        title="Refund Policy"
        bgUrl="https://png.pngtree.com/thumb_back/fh260/background/20210814/pngtree-business-gradient-geometric-gray-square-abstract-simple-gray-background-image_759189.jpg"
      />

      <Section pt="120" pb="100">
        <div className="container">
          <div className="refund-content">
            <h2 className="fw-bold mb-4">Refund Policy - Riyansh Solar Power Plus</h2>

            <p className="mb-4">
              At Riyansh Solar Power Plus, all payments for our products, services, or franchise fees are strictly non-refundable.
            </p>

            <h4 className="mt-4">Payment Guidelines</h4>
            <ul className="mb-3 ps-3">
              <li>
                All payments must be made directly to the official Riyansh Solar Power Plus account. Payments sent to any other account will not be recognized.
              </li>
              <li>
                Riyansh Solar Power Plus is not responsible for any payments made to unauthorized accounts or third parties.
              </li>
              <li>
                Customers and franchisees must verify account details before making any payment to ensure the transaction is valid.
              </li>
            </ul>

            <h4 className="mt-4">No Refund Policy</h4>
            <ul className="mb-3 ps-3">
              <li>Once a payment is completed, it cannot be canceled, refunded, or transferred under any circumstances.</li>
              <li>Please ensure you review all product, service, and franchise details before making a payment.</li>
              <li>Any disputes regarding payments made to incorrect accounts will not be entertained.</li>
            </ul>

            <h4 className="mt-4">Contact</h4>
            <p>
              For any inquiries regarding payments or our refund policy, please contact us at:<br/>
              Email: <a href="mailto:Info@riyanshsolar.com">Info@riyanshsolar.com</a><br/>
              Address: Office No 3, Venkatesh Plaza, Balaji Nagar, Station Road, Bhayandar West, Thane – 401101, Maharashtra
            </p>
          </div>
        </div>
      </Section>
    </>
  );
}
